import { render, staticRenderFns } from "./ContentDetails.vue?vue&type=template&id=73886de5&scoped=true&"
import script from "./ContentDetails.vue?vue&type=script&lang=js&"
export * from "./ContentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetails.vue?vue&type=style&index=0&id=73886de5&lang=scss&scoped=true&"
import style1 from "./ContentDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73886de5",
  null
  
)

export default component.exports